import { usePagamentoListar, useTituloPagamentoInserir } from "@/Services/Financeiro/Titulo/Pagamento/PagamentoServices";
import { Form, List, Row, Col, Button, notification, Flex, Divider } from "antd";
import PagamentoListItem from "./PagamentoListItem";
import PagamentoFormItem from "./PagamentoFormItem";
import Pagamento from "@/Models/Financeiro/Titulo/Pagamento/Pagamento";
import { PropriedadesDeNotificacao } from "@/Utils/Notificacoes";
import TituloPagamentoDesativarPopconfirm from "./TituloPagamentoDesativarPopconfirm";
import { MinusCircleOutlined, StopOutlined } from "@ant-design/icons";
import TituloPagamentoList from "./TituloPagamentoList";
import TituloPagamentoCancelamentoPopconfirm from "./TituloPagamentoCancelamentoPopconfirm";

export interface ITituloPagamentoFormProps {
    codTitulo : number;
}

export interface ITituloPagamentoFormType {
    pagamento:Pagamento;
}

export default function TituloPagamentoForm({
    codTitulo
}:ITituloPagamentoFormProps) {
    const [form] = Form.useForm<ITituloPagamentoFormType>();

    const {
        mutate,
        isPending
    } = useTituloPagamentoInserir({
        onSuccess() {
            form.resetFields();
            notification.open({
                ...PropriedadesDeNotificacao.Sucesso("Forma de pagamento cadastrada com sucesso.")
            });
        },
    });

    return <>
        <Form
            form={form}
            layout={"vertical"}
            autoComplete={"off"}
            onFinish={(entrada) => {
                entrada.pagamento.codTipo = entrada.pagamento.tipo!.codigo;
                entrada.pagamento.codTitulo = codTitulo;
                mutate(entrada.pagamento);
            }}
        >
            <Form.Item name={["pagamento", "codTitulo"]} initialValue={codTitulo} hidden></Form.Item>

            <PagamentoFormItem 
                form={form}
                nameBase={["pagamento"]}
                namePath={["pagamento"]}
            />

            <Col flex="auto">
                <Button type="primary" danger onClick={() => form.resetFields()}>Limpar</Button>
                {" "}<Button type="primary" onClick={() => form.submit()} loading={isPending}>Cadastrar</Button>
            </Col>
        </Form>
        <Divider>Formas de pagamento</Divider>
        <TituloPagamentoList 
            codTitulo={codTitulo}
            propsItem={{
                avatar : (pagamento) => (<>
                    <TituloPagamentoDesativarPopconfirm pagamento={pagamento}>
                        <Button type="text" danger>
                            <MinusCircleOutlined title="Remover" /> Remover
                        </Button>                                                                    
                    </TituloPagamentoDesativarPopconfirm>

                    <TituloPagamentoCancelamentoPopconfirm 
                        pagamento={pagamento}
                    >
                        <Button type="text" danger>
                            <StopOutlined title="Cancelamento" /> Cancelamento
                        </Button>
                    </TituloPagamentoCancelamentoPopconfirm>
                </>)
            }}
        />
        {/* <List 
            dataSource={data ?? []}
            loading={isLoading || isFetching}
            bordered
            renderItem={(pagamento) => <PagamentoListItem data={pagamento} avatar={
                <TituloPagamentoDesativarPopconfirm pagamento={pagamento}>
                    <Button type="text" danger>
                        <MinusCircleOutlined />    
                    </Button>                                                                    
                </TituloPagamentoDesativarPopconfirm>
            } />}
        /> */}
    </>
}